module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas"
  }, [_c('canvas', {
    attrs: {
      "id": "canvas",
      "width": "500",
      "height": "500"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6b49e007"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SunflowerComponent.vue
// module id = 126
// module chunks = 1